/* New Collection Slider — Splide initializer (continuous marquee via AutoScroll extension) */

document.addEventListener('DOMContentLoaded', function () {
  initNewCollectionSliders();
});

// In case the section is added/re-rendered via the theme editor
document.addEventListener('shopify:section:load', function (event) {
  initNewCollectionSliders(event.target);
});

function initNewCollectionSliders(scope) {
  var root = scope || document;
  var carousels = root.querySelectorAll('.new-collection-slider__carousel');

  carousels.forEach(function (el) {
    // Avoid double-initializing the same element
    if (el.dataset.splideInitialized === 'true') return;

    var waitForSplide = function () {
      var extensionsReady =
        typeof Splide !== 'undefined' &&
        window.splide &&
        window.splide.Extensions &&
        window.splide.Extensions.AutoScroll;

      if (!extensionsReady) {
        setTimeout(waitForSplide, 50);
        return;
      }

      var desktopColumns = parseFloat(el.dataset.desktopColumns) || 4;
      var mobileColumns = parseFloat(el.dataset.mobileColumns) || 2;
      var desktopSpeed = parseFloat(el.dataset.desktopSpeed) || 1;
      var mobileSpeed = parseFloat(el.dataset.mobileSpeed) || 1.2;
      var pauseOnHover = el.dataset.pauseOnHover === 'true';
      var arrows = el.dataset.arrows === 'true';
      var pagination = el.dataset.pagination === 'true';
      var gap = (el.dataset.gap || 16) + 'px';

      var splide = new Splide(el, {
        type: 'loop',
        drag: 'free',
        perPage: desktopColumns,
        perMove: 1,
        gap: gap,
        arrows: arrows,
        pagination: pagination,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: true,
        autoScroll: {
          speed: desktopSpeed,
          pauseOnHover: pauseOnHover,
          pauseOnFocus: true,
        },
        breakpoints: {
          989: {
            perPage: Math.max(1, Math.round(desktopColumns / 2)),
          },
          749: {
            perPage: mobileColumns,
            gap: '10px',
            autoScroll: {
              speed: mobileSpeed,
            },
          },
        },
      });

      splide.mount(window.splide.Extensions);
      el.dataset.splideInitialized = 'true';
    };

    waitForSplide();
  });
}